module.exports = __webpack_public_path__ + "static/img/game-head-dcpxdcg.4f5e0aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-head-dcpxdcg.png
// module id = ujSe
// module chunks = 1